<script setup>
import { computed } from 'vue';

const props = defineProps({
  count: { type: [Number, String], default: 0 },
  highlight: { type: Boolean, default: false },
  showZero: { type: Boolean, default: false },
  format: { type: String, default: 'pill' },
});

const normalizedCount = computed(() => {
  const count = Number(props.count);
  return Number.isFinite(count) && count > 0 ? count : 0;
});

const displayCount = computed(() =>
  normalizedCount.value > 99 ? '99+' : String(normalizedCount.value)
);

const shouldRender = computed(() => props.showZero || normalizedCount.value > 0);
</script>

<template>
  <span
    v-if="shouldRender"
    data-test-id="sidebar-unread-badge"
    :class="[
      format === 'text'
        ? 'text-xs font-medium tabular-nums'
        : 'inline-grid h-5 min-w-5 place-items-center rounded-full px-1 text-xxs font-medium leading-3 flex-shrink-0',
      highlight
        ? 'text-n-ruby-10 bg-n-ruby-4 dark:bg-n-ruby-5'
        : 'text-n-slate-12 bg-n-slate-4 dark:bg-n-slate-5',
      format === 'text' ? '!bg-transparent dark:!bg-transparent' : '',
    ]"
  >
    {{ format === 'text' ? `(${displayCount})` : displayCount }}
  </span>
  <span v-else class="hidden" />
</template>
